import React from 'react'
import styled from "styled-components"


const StyledMark = styled.mark`
    color: ${({ theme }) => theme.colors.plainText};
`

// Define functional component. Destructure the props.
const Taggy = ({ text = '', spans = [], ents = []}) => {

    // Find the correct color of the given entity type. If the given entity is not found, set the color to grey.
    const findRed = (type) => {
        for (let e = 0; e < ents.length; e++) {
            if (ents[e].type === type) {
                return ents[e].color.r
            }
        }
        return 220
    }
    const findgreen = (type) => {
        for (let e = 0; e < ents.length; e++) {
            if (ents[e].type === type) {
                return ents[e].color.g
            }
        }
        return 220
    }
    const findBlue = (type) => {
        for (let e = 0; e < ents.length; e++) {
            if (ents[e].type === type) {
                return ents[e].color.b
            }
        }
        return 220
    }

    const findAlphaOpacity = (type) => {
        for (let e = 0; e < ents.length; e++) {
            if (ents[e].type === type) {
                return ents[e].color.a
            }
        }
        return 0.2
    }

    // Initialize an empty array that will hold the text and entities
    let jsx = []

    // METHOD 1 - STRING
    if (typeof text === 'string') {
        // Initialize an empty array. The contents of 'elements' will eventually get pushed to the 'jsx' array, and will be converted to jsx markup in the process.
        let elements = []
        // Keep track of location in the string of text
        let offset = 0
        // Loop through the spans, using the span data to construct the 'elements' array
        spans.forEach(({ type, start, end }) => {
            // Create a string of text that does not contain any entities
            const fragment = text.slice(offset, start)
            // Create an entity
            const entity = text.slice(start, end)
            // Push the both of them to the elements array
            elements.push(fragment)
            elements.push({
                token: entity,
                type: type.toLowerCase()
            })
            // Update our position within the string of text
            offset = end
        })
        // After pushing all of the entities to the 'elements' array, push the remaining text to the 'elements' array. Elements should now consist of strings and objects/entities.
        elements.push(text.slice(offset, text.length))
        // Filter out unnecessary spaces
        elements = elements.filter(val => val !== ' ')
        // Loop through elements array looking for multi-word entities.
        for (let e = 0; e < elements.length; e++) {
            // Check if we've stopped at an entity
            if (elements[e].token) {
                // Examine the consecutive entities, if any.
                for (let i = e + 1; i < elements.length; i++) {
                    // Combine consecutive entities of the same type into one entity. Then, mark the duplicates as 'false'.
                    if (typeof elements[i] !== 'string' && elements[i].type === elements[e].type) {
                        elements[e].token += ' ' + elements[i].token
                        elements[i] = false
                    }
                    // Stop the loop when we've run out of consecutive entities
                    if (typeof elements[i] === 'string') {
                        break
                    }
                }
            }
        }
        // Filter out the consecutive entities that were marked as duplicates
        elements = elements.filter(val => !!val)
        // Loop through our 'elements' array. Push strings directly to the 'jsx' array. Convert entity objects to jsx markup, then push to the 'jsx' array.
        elements.forEach(t => {
            if (typeof t === 'string') {
                jsx.push(t)
            }
            else {
                jsx.push(
                    <StyledMark
                        style={{
                            
                            lineHeight: '0.94112rem',
                            display: 'inline',
                            fontSize: '0.94112rem',
                            fontWeight: '500',
                            borderBottomRightRadius: '0.35292rem',
                            borderBottom: `2px solid rgb(
                                ${findRed(t.type)},
                                ${findgreen(t.type)},
                                ${findBlue(t.type)}
                            )`,
                            background: 'transparent',
                        }}
                    >
                        {t.token}
                        <span
                            style={{
                                borderRadius: '0.35292rem',
                                display: 'inline',
                                margin: '0.25rem',
                                marginBottom: '0',
                                marginRight: 0,
                                fontWeight: '600',
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: 'border-box',
                                    fontSize: '0.67643rem',
                                    lineHeight: '0.82348rem',
                                    padding: '0.23528rem 0.35292rem',
                                    borderRadius: '0.35292rem',
                                    borderBottomLeftRadius: '0',
                                    display: 'inline',
                                    verticalAlign: 'middle',
                                    fontWeight: '600',
                                    color: `white`,
                                    background: `rgb(
                                        ${findRed(t.type)},
                                        ${findgreen(t.type)},
                                        ${findBlue(t.type)}
                                    )`,
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {t.type}
                            </span>
                        </span>
                    </StyledMark>
                )
            }
        })
    }

    // METHOD 2 - TOKENS
    if (Array.isArray(text)) {
        // Rename 'text' to 'tokens' for clarity
        let tokens = text
        // Loop through the 'spans' array. Use the span data to update our 'tokens' array with entities
        for (let s = 0; s < spans.length; s++) {
            tokens[spans[s].index] = {
                token: tokens[spans[s].index],
                type: spans[s].type.toLowerCase()
            }
        }
        // Loop through the tokens array, looking for multi-word entities
        for (let t = 0; t < tokens.length; t++) {
            // Check if we've stopped at an entity
            if (tokens[t].token) {
                // Examine the consecutive entities, if any.
                for (let i = t + 1; i < tokens.length; i++) {
                    // Combine consecutive entities of the same type into one entity. Then, mark the duplicates as 'false'.
                    if (typeof tokens[i] !== 'string' && tokens[i].type === tokens[t].type) {
                        tokens[t].token += ' ' + tokens[i].token
                        tokens[i] = false
                    }
                    // Stop the loop when we've run out of consecutive entities
                    if (typeof tokens[i] === 'string') {
                        break
                    }
                }
            }
        }
        // Filter out the consecutive entities that were marked as duplicates
        tokens = tokens.filter(val => !!val)
        // Add a space to the end of each string/non-entity
        let tokensWithSpaces = tokens.map(t => {
            if (typeof t === 'string') {
                return `${t} `
            }
            return t
        })
        // Loop through our 'tokens' array. Push strings directly to the 'jsx' array. Convert entity objects to jsx markup, then push to the 'jsx' array.
        tokensWithSpaces.forEach(t => {
            if (typeof t === 'string') {
                jsx.push(t)
            }
            else {
                jsx.push(
                    <mark
                        style={{
                            
                            lineHeight: '0.94112rem',
                            display: 'inline',
                            fontSize: '0.94112rem',
                            fontWeight: '500',
                            borderBottomRightRadius: '0.35292rem',
                            borderBottom: `2px solid rgb(
                                ${findRed(t.type)},
                                ${findgreen(t.type)},
                                ${findBlue(t.type)}
                            )`,
                            background: 'transparent',
                            color: 'white',
                        }}
                    >
                        {t.token}
                        <span
                            style={{
                                borderRadius: '0.35292rem',
                                display: 'inline',
                                margin: '0.25rem',
                                marginBottom: '0',
                                marginRight: 0,
                                fontWeight: '600',
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: 'border-box',
                                    fontSize: '0.67643rem',
                                    lineHeight: '0.82348rem',
                                    padding: '0.23528rem 0.35292rem',
                                    borderRadius: '0.35292rem',
                                    borderBottomLeftRadius: '0',
                                    display: 'inline',
                                    verticalAlign: 'middle',
                                    fontWeight: '600',
                                    color: `white`,
                                    background: `rgb(
                                        ${findRed(t.type)},
                                        ${findgreen(t.type)},
                                        ${findBlue(t.type)}
                                    )`,
                                    color: `white`,
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {t.type}
                            </span>
                        </span>
                    </mark>
                )
            }
        })
    }

    // Return the markup
    return (
        <div>
            {jsx.map((j, i) => (
                <span key={i}>{j}</span>
            ))}
        </div>
    )

}

export default Taggy
